import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Slide, ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "../styles/ContactPage.css";
import Footer from "../../../../components/Footer/Footer";
import { fetchContactDetails, submitContactForm } from "../redux/contactSlice";
import useContactForm from "../hooks/useContactForm";
import ContactForm from "../components/ContactForm";
import ContactInfo from "../components/ContactInfo";
import HelpGuides from "../components/HelpGuides";

export default function ContactPage() {
  const dispatch = useDispatch();
  const { loading, details } = useSelector((state) => state.contact);

  /* -------------------- PAGE SETUP -------------------- */
  useEffect(() => {
    document.title = "Obsession - Contact Us";
    dispatch(fetchContactDetails());
  }, [dispatch]);

  /* -------------------- FORM SUBMIT -------------------- */
  const handleFormSubmit = async (values, resetForm) => {
    try {
      await dispatch(submitContactForm(values)).unwrap();

      toast.success("Message sent successfully", {
        autoClose: 3000,
        iconTheme: {
          primary: "#713200",
          secondary: "#FFFAEE",
        },
      });

      resetForm();
    } catch (err) {
      toast.error(
        err || "Message must be at least 30 characters long.",
        {
          autoClose: 3000,
        }
      );
    }
  };

  /* -------------------- FORM HOOK (ONLY ONCE) -------------------- */
  const {
    values,
    errors,
    handleChange,
    handleSubmit,
  } = useContactForm(handleFormSubmit);

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={3000}
        limit={1}
        hideProgressBar
        transition={Slide}
        newestOnTop
        style={{ zIndex: 99999999 }}

      />

      <div className="contact-page">
        {/* HERO */}
        <section
          className="contact-hero"
          style={{
            backgroundImage: `url(${details?.data?.contact_image})`,
          }}
        />

        {/* MAIN SECTION */}
        <section className="contact-section">
          {/* MOBILE FORM */}
          <div className="mobileres">
            <ContactForm
              formData={values}
              errors={errors}
              loading={loading}
              onChange={handleChange}
              onSubmit={handleSubmit}
              title="Send Us a Message"
            />
          </div>

          {/* CONTACT INFO */}
          <ContactInfo data={details?.data} />

          {/* DESKTOP FORM */}
          <div className="webres">
            <ContactForm
              formData={values}
              errors={errors}
              loading={loading}
              onChange={handleChange}
              onSubmit={handleSubmit}
              title="Send Us a Message"
            />
          </div>
        </section>

        {/* HELP GUIDES */}
        <HelpGuides />
      </div>

      <Footer />
    </>
  );
}
